export default __webpack_public_path__ + "static/error-b90f4eff281d740d7a7bf3e906d4da63.svg";